(function () {
  if (window.__novvuPhotoUploadScriptLoaded) return;
  window.__novvuPhotoUploadScriptLoaded = true;

  var ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
  var ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp', 'gif'];

  function getProductForm() {
    var productForm = document.querySelector('product-form[data-main="true"] form');
    return productForm || document.querySelector('form[data-type="add-to-cart-form"]');
  }

  function getUploaders() {
    return Array.prototype.slice.call(document.querySelectorAll('product-photo-upload'));
  }

  function getVisibleUploaders() {
    return getUploaders().filter(function (uploader) {
      return uploader.offsetParent !== null;
    });
  }

  function getInputs(uploader) {
    return Array.prototype.slice.call(uploader.querySelectorAll('[data-photo-upload-input]'));
  }

  function getFilledInputs(uploader) {
    return getInputs(uploader).filter(function (input) {
      return input.files && input.files.length > 0;
    });
  }

  function setFormAttributes(uploader) {
    var form = getProductForm();
    if (!form || !form.id) return;

    form.setAttribute('enctype', 'multipart/form-data');
    form.setAttribute('encoding', 'multipart/form-data');
    getInputs(uploader).forEach(function (input) {
      input.setAttribute('form', form.id);
    });
  }

  function getExtension(fileName) {
    return String(fileName || '').split('.').pop().toLowerCase();
  }

  function formatMessage(template, values) {
    return String(template || '').replace(/\[([a-z_]+)\]/gi, function (_, key) {
      return values[key] || '';
    });
  }

  function getMessage(uploader, key, fallback) {
    return uploader.dataset[key] || fallback;
  }

  function validateFile(uploader, file) {
    var maxSizeMb = parseFloat(uploader.dataset.maxSizeMb || '10');
    var extension = getExtension(file.name);
    var typeValid = ALLOWED_TYPES.indexOf(file.type) !== -1 || ALLOWED_EXTENSIONS.indexOf(extension) !== -1;

    if (!typeValid) {
      return getMessage(uploader, 'typeMessage', 'Te rugam sa incarci doar poze JPG, PNG, WEBP sau GIF.');
    }

    if (maxSizeMb > 0 && file.size > maxSizeMb * 1024 * 1024) {
      return formatMessage(
        getMessage(uploader, 'sizeMessage', 'Poza este prea mare. Limita este [max_size] MB.'),
        { max_size: String(maxSizeMb) }
      );
    }

    return '';
  }

  function setMessage(uploader, message, isValid) {
    var messageElement = uploader.querySelector('[data-photo-upload-message]');
    uploader.classList.toggle('product-photo-upload--valid', !!isValid);
    if (messageElement) messageElement.textContent = message || '';
  }

  function updateCounter(uploader) {
    var counter = uploader.querySelector('[data-photo-upload-counter]');
    var filled = getFilledInputs(uploader).length;
    var maxFiles = parseInt(uploader.dataset.maxFiles || '1', 10);
    if (counter) counter.textContent = filled + '/' + maxFiles;
  }

  function clearInput(input) {
    input.value = '';
    var slot = input.closest('[data-photo-upload-slot]');
    if (!slot) return;

    var preview = slot.querySelector('[data-photo-upload-preview]');
    var image = slot.querySelector('[data-photo-upload-preview-image]');
    var filename = slot.querySelector('[data-photo-upload-filename]');

    slot.classList.remove('product-photo-upload__slot--has-file', 'product-photo-upload__slot--error');
    if (image) {
      if (image.dataset.objectUrl) URL.revokeObjectURL(image.dataset.objectUrl);
      image.removeAttribute('src');
      image.dataset.objectUrl = '';
    }
    if (filename) filename.textContent = '';
    if (preview) preview.hidden = true;
  }

  function renderPreview(input) {
    var slot = input.closest('[data-photo-upload-slot]');
    var file = input.files && input.files[0];
    if (!slot || !file) return;

    var preview = slot.querySelector('[data-photo-upload-preview]');
    var image = slot.querySelector('[data-photo-upload-preview-image]');
    var filename = slot.querySelector('[data-photo-upload-filename]');

    slot.classList.add('product-photo-upload__slot--has-file');
    slot.classList.remove('product-photo-upload__slot--error');

    if (image) {
      if (image.dataset.objectUrl) URL.revokeObjectURL(image.dataset.objectUrl);
      image.dataset.objectUrl = URL.createObjectURL(file);
      image.src = image.dataset.objectUrl;
      image.alt = file.name;
    }
    if (filename) filename.textContent = file.name;
    if (preview) preview.hidden = false;
  }

  function validateUploader(uploader, focusInvalid) {
    setFormAttributes(uploader);

    var minFiles = parseInt(uploader.dataset.minFiles || '1', 10);
    var filledInputs = getFilledInputs(uploader);
    var firstInvalidInput = null;
    var errorMessage = '';

    getInputs(uploader).forEach(function (input) {
      var slot = input.closest('[data-photo-upload-slot]');
      if (slot) slot.classList.remove('product-photo-upload__slot--error');

      if (!input.files || !input.files[0] || errorMessage) return;

      var message = validateFile(uploader, input.files[0]);
      if (message) {
        errorMessage = message;
        firstInvalidInput = input;
        if (slot) slot.classList.add('product-photo-upload__slot--error');
      }
    });

    if (!errorMessage && filledInputs.length < minFiles) {
      errorMessage = formatMessage(
        getMessage(uploader, 'requiredMessage', 'Te rugam sa incarci poza inainte de a adauga produsul in cos.'),
        { min_files: String(minFiles) }
      );

      getInputs(uploader).some(function (input) {
        if (input.files && input.files.length > 0) return false;
        firstInvalidInput = input;
        var slot = input.closest('[data-photo-upload-slot]');
        if (slot) slot.classList.add('product-photo-upload__slot--error');
        return true;
      });
    }

    if (errorMessage) {
      setMessage(uploader, errorMessage, false);
      if (focusInvalid && firstInvalidInput) firstInvalidInput.focus();
      return false;
    }

    if (filledInputs.length > 0) {
      setMessage(uploader, getMessage(uploader, 'readyMessage', 'Pozele sunt pregatite.'), true);
    } else {
      setMessage(uploader, '', false);
    }

    return true;
  }

  function validateAllUploaders(focusInvalid) {
    var uploaders = getVisibleUploaders();

    for (var i = 0; i < uploaders.length; i += 1) {
      if (!validateUploader(uploaders[i], focusInvalid)) return false;
    }

    return true;
  }

  function appendUploadFilesToFormData(formData) {
    if (!formData || typeof formData.set !== 'function') return formData;

    getVisibleUploaders().forEach(function (uploader) {
      getFilledInputs(uploader).forEach(function (input) {
        if (!input.name || !input.files || !input.files[0]) return;
        formData.set(input.name, input.files[0], input.files[0].name);
      });
    });

    return formData;
  }

  function handleBlockingEvent(event) {
    if (validateAllUploaders(true)) {
      return true;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    return false;
  }

  function isMainProductSubmit(form) {
    var productForm = getProductForm();
    return !!form && !!productForm && form === productForm;
  }

  function isMainProductButton(button) {
    if (!button || button.closest('cart-drawer, .cart-drawer')) return false;
    if (button.closest('product-form[data-main="true"]')) return true;
    return button.classList.contains('main-product-atc') || button.id.indexOf('ProductSubmitButton-') === 0;
  }

  function bindUploader(uploader) {
    setFormAttributes(uploader);
    updateCounter(uploader);

    getInputs(uploader).forEach(function (input) {
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (!file) {
          clearInput(input);
          updateCounter(uploader);
          validateUploader(uploader, false);
          return;
        }

        var message = validateFile(uploader, file);
        if (message) {
          clearInput(input);
          setMessage(uploader, message, false);
          var slot = input.closest('[data-photo-upload-slot]');
          if (slot) slot.classList.add('product-photo-upload__slot--error');
          updateCounter(uploader);
          return;
        }

        renderPreview(input);
        updateCounter(uploader);
        validateUploader(uploader, false);
      });
    });

    uploader.addEventListener('click', function (event) {
      var removeButton = event.target.closest('[data-photo-upload-remove]');
      if (!removeButton) return;

      var slot = removeButton.closest('[data-photo-upload-slot]');
      var input = slot && slot.querySelector('[data-photo-upload-input]');
      if (!input) return;

      clearInput(input);
      updateCounter(uploader);
      setMessage(uploader, getMessage(uploader, 'emptyMessage', 'Poza a fost stearsa. Adauga alta poza.'), false);
    });
  }

  function bind() {
    getUploaders().forEach(bindUploader);

    document.addEventListener('submit', function (event) {
      if (!isMainProductSubmit(event.target)) return;
      handleBlockingEvent(event);
    }, true);

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[name="add"], .main-product-atc, [data-skip-cart-button="true"]');
      if (!isMainProductButton(button)) return;
      handleBlockingEvent(event);
    }, true);

    var originalFetch = window.fetch;
    if (typeof originalFetch === 'function' && !window.__novvuPhotoUploadFetchPatched) {
      window.__novvuPhotoUploadFetchPatched = true;
      window.fetch = function () {
        var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';

        if (url.indexOf('/cart/add') !== -1 && getVisibleUploaders().length > 0 && !validateAllUploaders(true)) {
          return Promise.resolve(new Response(JSON.stringify({ error: 'invalid_photo_upload' }), {
            status: 422,
            headers: { 'Content-Type': 'application/json' }
          }));
        }

        if (url.indexOf('/cart/add') !== -1 && getVisibleUploaders().length > 0 && arguments[1] && arguments[1].body instanceof FormData) {
          arguments[1].body = appendUploadFilesToFormData(arguments[1].body);
        }

        return originalFetch.apply(this, arguments);
      };
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
